export default __webpack_public_path__ + "static/media/vietnam.e4410c7b.svg";